import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';



 


function GestionEquipe(props) {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [equipe,setEquipe] = useState(null)
  const [supprimer,setSupprimer] = useState(false)
  const [joueur_supp,setJoueur_supp]  = useState(null)
  const [success,setSucces]  = useState(false)
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {

    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/recherche/equipe-arbitre`,
          {
            id_equipe : props.userData.user.donnée.results[0].id_equipe 
          },
              {
                withCredentials: true // Permet de transmettre les cookies avec la requête
              }

        );

        
        setEquipe(response.data);
        setError(null);
        setIsLoading(false);
      } catch (error) {
        setError(error.data)
        setIsLoading(false);
      }
    };

    fetchData(); 

}, [apiUrl, props.userData])


const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); 
    setSupprimer(false);
    setSucces(false)




    if (!joueur_supp) {
      setError("Erreur");
      setIsLoading(false);
      return;
    }

    try {
        await axios.delete(`${apiUrl}/parametre/suppression/joueur`, 
        {
          withCredentials: true, // Inclut les cookies dans la requête
          data: {
            id: joueur_supp[0].id,
            nom: joueur_supp[0].nom,
            prenom:joueur_supp[0].prenom
          }
      });

        setError(null);
        setIsLoading(false);
        setSucces(true);
        setJoueur_supp([]);
        setTimeout(() => {
            setSucces(false);
            window.location.reload(); 
          }, 20000); 

      } 
      catch (error) {
        setIsLoading(false);
        if (error.response) {
        
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
      }
    };
  






        
  return (
  <>
    {isLoading && (
    <>
      <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
      </div>
    </>

  )}
  {supprimer && (
      <Modal show={supprimer} onHide={() => {setSupprimer(false); setJoueur_supp([])}}>
        <Modal.Header closeButton>
          <Modal.Title>Êtes-vous sûr de supprimer ce joueur ?</Modal.Title>
        </Modal.Header>
        <Modal.Body>        
            <>Êtes-vous sûr de supprimer le joueur {joueur_supp[0].nom} {joueur_supp[0].prenom} ?</>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {setSupprimer(false); setJoueur_supp([])}}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleSubmit} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>
      )}
  {props.userData ? (
  <>
        <h2 style={{textAlign:"center"}}>Modifier l'équipe</h2>
        {error && (
                <Alert key="danger" variant="danger" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                    Erreur ! {error}. 
                </Alert>
                )}
                {success && (
                        <Alert key="success" variant="success" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                        Félicitations ! Joueur supprimé avec succès.
                      </Alert>
              )}
          <div className="card-body">
            <div className="ajout2 tab">
            <Table striped bordered hover>
                <thead>
                    <tr>
                    <th>#</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Poste</th>
                    <th>Retirer de l'équipe</th>
                    </tr>
                </thead>
            <tbody>
            {equipe && equipe.gardien.map((item, index) => (
                    <tr key={index}>
                        <td>{item.numero}</td>
                        <td>{item.nom}</td>
                        <td>{item.prenom}</td>
                        <td>Gardien</td>
                        <td><button onClick={() => {setSupprimer(true); setJoueur_supp([{id: item.id_joueur, nom: item.nom, prenom: item.prenom}])}}  className="supprimer_">Supprimer</button></td>
                    </tr>

                ))}
                {equipe && equipe.defenseur.map((item, index) => (
                    <tr key={index}>
                    <td>{item.numero}</td>
                    <td>{item.nom}</td>
                    <td>{item.prenom}</td>
                    <td>Défenseur</td>
                    <td><button onClick={() => {setSupprimer(true); setJoueur_supp([{id: item.id_joueur, nom: item.nom, prenom: item.prenom}])}}  className="supprimer_">Supprimer</button></td>
                </tr>
                ))}
                {equipe && equipe.milieu.map((item, index) => (
                    <tr key={index}>
                        <td>{item.numero}</td>
                        <td>{item.nom}</td>
                        <td>{item.prenom}</td>
                        <td>Milieu</td>
                        <td><button onClick={() => {setSupprimer(true); setJoueur_supp([{id: item.id_joueur, nom: item.nom, prenom: item.prenom}])}}  className="supprimer_">Supprimer</button></td>
                </tr>
                ))}
                {equipe && equipe.attaquant.map((item, index) => (
                    <tr key={index}>
                        <td>{item.numero}</td>
                        <td>{item.nom}</td>
                        <td>{item.prenom}</td>
                        <td>Attaquant</td>
                        <td><button onClick={() => {setSupprimer(true); setJoueur_supp([{id: item.id_joueur, nom: item.nom, prenom: item.prenom}])}}  className="supprimer_">Supprimer</button></td>
                </tr>
                ))}
                {equipe && equipe.autre.map((item, index) => (
                    <tr key={index}>
                        <td>/</td>
                        <td>{item.nom}</td>
                        <td>{item.prenom}</td>
                        <td>Pas inscrit</td>
                        <td><button onClick={() => {setSupprimer(true); setJoueur_supp([{id: item.id_joueur, nom: item.nom, prenom: item.prenom}])}}  type="submit" className="supprimer_">Supprimer</button></td>
                </tr>
                ))}


            </tbody>
            </Table>
            </div>
          </div>

      </>
      ) :(
        <>       
      <div id="alert-message" className="alert" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div></>
      )}
  </>
  );
}

export default GestionEquipe;
